import React from "react";
import { Link } from "react-router-dom";
import useSeo from "@/hooks/useSeo";
import { Button } from "@/components/kit";

const NotFoundPage = () => {
  useSeo({
    title: "Pagina niet gevonden",
    description: "De pagina die je zoekt bestaat niet (meer). Ga terug naar de homepage.",
    path: "/404",
    noindex: true,
  });

  return (
    <main data-testid="notfound-page" className="min-h-[85vh] grid place-items-center bg-obsidian px-6 relative overflow-hidden">
      <div className="absolute inset-0 grid-dark opacity-60" />
      <div className="glow-orb w-[500px] h-[500px] bg-electric/25 top-1/4 left-1/2 -translate-x-1/2" />
      <div className="relative text-center max-w-md">
        <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-electric-300 mb-4">404 · Niet gevonden</div>
        <h1 className="font-display text-6xl lg:text-8xl font-black tracking-tight text-ivory mb-6">
          Oeps.
        </h1>
        <p className="text-white/60 mb-9">
          De pagina die je zoekt bestaat niet (meer). Ga terug naar de homepage of bekijk onze diensten.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button to="/" variant="primary" testid="notfound-home">Naar home</Button>
          <Button to="/diensten" variant="outlineLight" testid="notfound-diensten">Bekijk diensten</Button>
        </div>
      </div>
    </main>
  );
};

export default NotFoundPage;
